import React, { lazy, Suspense, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import { Button } from "antd";

import "react-toastify/dist/ReactToastify.css";

import Header from "./components/navigation/Header";
import MainMenu from "./components/navigation/MainMenu";

import { loginUser } from "./reducers/userSlice";
import { estoreDet } from "./reducers/estoreSlice";
import { appendEstore } from "./reducers/estoresSlice";

const Login = lazy(() => import("./pages/auth/Login"));
const Payment = lazy(() => import("./pages/auth/Payment"));

const Stores = lazy(() => import("./pages/store/Stores"));
const Owners = lazy(() => import("./pages/owner/Owners"));
const Package = lazy(() => import("./pages/package/Package"));
const Billing = lazy(() => import("./pages/billing/Billing"));
const Affiliate = lazy(() => import("./pages/affiliate/Affiliate"));
const Payments = lazy(() => import("./pages/payment/Payments"));
const Instructions = lazy(() => import("./pages/help/Instructions"));
const Settings = lazy(() => import("./pages/settings/Main.js"));
const Training = lazy(() => import("./pages/training/Training"));

function App() {
  const dispatch = useDispatch();
  const userToken = localStorage.getItem("userToken");

  const user = useSelector((state) => state.user);
  const estore = useSelector((state) => state.estore);

  const [menu, setMenu] = useState("");
  const [totalRemit, setTotalRemit] = useState({ total: 0, overdue: false });
  const [showPrime, setShowPrime] = useState(false);

  useEffect(() => {
    const date1 = new Date(estore.createdAt);
    const date2 = new Date();
    const timeDifference = date2.getTime() - date1.getTime();
    const daysDifference = Math.round(timeDifference / (1000 * 3600 * 24));

    if (daysDifference && daysDifference > 380) setShowPrime(true);
  }, [estore && estore._id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userToken) {
      handleUserDetails(userToken);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleUserDetails = async (token) => {
    const user = await axios.get(
      process.env.REACT_APP_RESELL_API +
        "/gratis/user-details/" +
        process.env.REACT_APP_MASTERID,
      {
        headers: {
          authToken: token,
        },
      },
    );
    if (user.data.err) {
      toast.error(user.data.err);
    } else {
      if (user.data.estoreid.reseller.status) {
        localStorage.setItem("userToken", token);
        dispatch(
          loginUser({
            ...user.data,
            token,
            masterUser:
              user.data.estoreid._id === process.env.REACT_APP_MASTERID,
          }),
        );
        dispatch(estoreDet(user.data.estoreid));
        dispatch(
          appendEstore({
            estoreId: user.data.estoreid._id,
            storeName: user.data.estoreid.name || user.data.estoreid.slug,
            token,
            user: {
              ...user.data,
              token,
              masterUser:
                user.data.estoreid._id === process.env.REACT_APP_MASTERID,
            },
            estore: user.data.estoreid,
          }),
        );
      } else {
        toast.error("Sorry, your login details has no reseller account.");
      }
    }
  };

  return (
    <div>
      {user._id ? (
        <>
          <Header setTotalRemit={setTotalRemit} />
          <div style={{ display: isMobile ? "block" : "flex" }}>
            <div
              style={{
                position: isMobile ? "unset" : "fixed",
                top: 60,
                height: isMobile ? "0px" : "100%",
                paddingBottom: isMobile ? "60px" : "0",
                backgroundColor: isMobile ? "" : "#000000",
              }}
            >
              <MainMenu menu={menu} />
            </div>
            <div
              style={{
                width: "100%",
                padding: isMobile ? "72px 5px 0 5px" : "72px 20px 0 265px",
              }}
            >
              <Suspense
                fallback={
                  <div className="col text-center p-5">
                    <LoadingOutlined />
                  </div>
                }
              >
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      <Stores setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/stores"
                    element={
                      <Stores setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/owners"
                    element={
                      <Owners setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/package"
                    element={
                      <Package setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/billing"
                    element={
                      <Billing setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/billing/:estoreid"
                    element={
                      <Billing setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/affiliate"
                    element={
                      <Affiliate setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  <Route
                    exact
                    path="/payments"
                    element={
                      <Payments setMenu={setMenu} totalRemit={totalRemit} />
                    }
                  />
                  Training
                  <Route
                    exact
                    path="/trainings"
                    element={<Training setMenu={setMenu} />}
                  />
                  <Route
                    exact
                    path="/instruct"
                    element={<Instructions setMenu={setMenu} />}
                  />
                  <Route
                    exact
                    path="/settings"
                    element={<Settings setMenu={setMenu} />}
                  />
                  <Route
                    exact
                    path="/instruct/:videoid"
                    element={<Instructions setMenu={setMenu} />}
                  />
                </Routes>
              </Suspense>
              {isMobile && (
                <>
                  <div style={{ padding: 10, clear: "both" }}>
                    <br />
                    <br />
                    <strong>Reseller Asking Price</strong>
                    <br />
                    1. Basic Account: 0%
                    <br />
                    2. Dedicated Account 1: 12,990
                    <br />
                    3. Dedicated Account 2: 32,990
                  </div>
                  {showPrime && (
                    <div style={{ padding: 10 }}>
                      <br />
                      P.S. Stop paying Reseller Asking Price by owning the whole
                      system. Take full control by getting all the codes and
                      solely accessing the server. <br />
                      <Button
                        type="primary"
                        size="medium"
                        style={{
                          borderRadius: 6,
                        }}
                        onClick={() =>
                          window.open(
                            "https://francisclavano.clavstore.com/prime",
                            "_blank",
                          )
                        }
                      >
                        Learn More
                      </Button>
                      <br />
                      <br />
                      <br />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <Suspense
          fallback={
            <div className="col text-center p-5">
              <LoadingOutlined />
            </div>
          }
        >
          <Routes>
            Payment
            <Route exact path="/" element={<Login />} />
            <Route exact path="/training" element={<Training />} />
            <Route exact path="/payment/:type" element={<Payment />} />
          </Routes>
        </Suspense>
      )}
      <ToastContainer />
    </div>
  );
}

export default App;
